import { ref, onMounted, onUnmounted } from 'vue';
import http from '@/http.js';
import eventBus from '@/eventBus.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useJeuRequetesFunctions = (props) => {
    const idJeuRequetes = ref('');
    const requetes = ref([]);
    const requetesNot = ref([]);
    const requetesFrom = ref([]);
    const lRequeteJeuRequetesList = ref([]);
    const showModalModifierJeu = ref(false);
    const showModalRequetesIn = ref(false);
    const showModalRequetesOut = ref(false);
    const loaded = ref(true);

    const showNotification = ref(false);
    const notificationMessage = ref('');
    const notificationType = ref('info');

    const handleNotification = ({ toastMessage, toastType }) => {
        notificationMessage.value = toastMessage;
        notificationType.value = toastType;
        showNotification.value = true;
        setTimeout(() => {
            showNotification.value = false;
        }, 5000);
    };

    const say = () => {
        eventBus.emit('notification', {
            toastMessage: "Impossible d'effacer ce jeu car il comporte une ou plusieurs requêtes",
            toastType: 'danger'
        });
    };

    const handleShowModalRequeteInJeu = (idJeuRequetes) => {
        loaded.value = false;
        http.getRequetesInJeu(idJeuRequetes).then((data) => {
            requetes.value = data;
        }).finally(() => {
            loaded.value = true;
        });
        showModalRequetesIn.value = !showModalRequetesIn.value;
        showModalRequetesOut.value = false;
        showModalModifierJeu.value = false;
    };

    const handleShowModalRequeteNotInJeu = (idJeuRequetes) => {
        loaded.value = false;
        http.getRequetesNotInJeu(idJeuRequetes).then((data) => {
            requetesNot.value = data;
        }).finally(() => {
            loaded.value = true;
        });
        showModalRequetesOut.value = !showModalRequetesOut.value;
        showModalRequetesIn.value = false;
        showModalModifierJeu.value = false;
    };

    const deleteJeuRequete = async (idJeuRequetes) => {
        const requetesInJeuRequete = await http.getRequetesInJeu(idJeuRequetes);
        requetes.value = requetesInJeuRequete;
        if (requetes.value.length === 0) {
            if (confirm(`Voulez-vous vraiment supprimer le jeu de requêtes : ${idJeuRequetes}`)) {
                try {
                    await http.deleteJeuRequete(idJeuRequetes);
                    eventBus.emit('reloadJeu');
                    window.scrollTo(0, 0);
                    eventBus.emit('notification', {
                        toastMessage: `Jeu ${idJeuRequetes} supprimé avec succès`,
                        toastType: 'success'
                    });
                } catch (error) {
                    console.error(error);
                }
            }
        } else {
            say();
        }
    };

    const insertRequetesFromJeu = async () => {
        try {
            await http.insertRequetesFromJeu(lRequeteJeuRequetesList.value);
            lRequeteJeuRequetesList.value.length = 0;
            requetesFrom.value.length = 0;
            eventBus.emit('reloadJeu');
            window.scrollTo(0, 0);
            showModalRequetesOut.value = false;
            eventBus.emit('notification', {
                toastMessage: 'Requête(s) ajoutée(s) au jeu !',
                toastType: 'success'
            });
        } catch (error) {
            console.error(error);
        }
    };

    const deleteRequeteFromJeu = async (idRequeteToDelete) => {
        if (confirm(`Voulez-vous vraiment supprimer la requête : ${idRequeteToDelete}`)) {
            try {
                await http.deleteRequeteFromJeu(props.JeuRequetesData.idJeuRequetes, idRequeteToDelete);
                eventBus.emit('reloadJeu');
                window.scrollTo(0, 0);
                showModalRequetesIn.value = false;
                eventBus.emit('notification', {
                    toastMessage: `Requête ${idRequeteToDelete} supprimée avec succès`,
                    toastType: 'success'
                });
            } catch (error) {
                console.error(error);
            }
        }
    };

    onMounted(() => {
        eventBus.on('addRequeteInJeu' + props.JeuRequetesData.idJeuRequetes, (RequeteToAdd) => {
            const lRequeteJeuRequetes = {
                idJeuRequetes: props.JeuRequetesData.idJeuRequetes,
                idRequete: RequeteToAdd.idRequete
            };
            lRequeteJeuRequetesList.value.push(lRequeteJeuRequetes);
            requetesFrom.value.push(RequeteToAdd);
        });

        eventBus.on('suppRequeteInJeu' + props.JeuRequetesData.idJeuRequetes, (idRequeteToSupp) => {
            const i = requetesFrom.value.map(requete => requete.idRequete).indexOf(idRequeteToSupp);
            requetesFrom.value.splice(i, 1);
            lRequeteJeuRequetesList.value.splice(i, 1);
        });

        eventBus.on('insertRequetesFromJeu' + props.JeuRequetesData.idJeuRequetes, insertRequetesFromJeu);

        eventBus.on('deleteRequeteFromJeu' + props.JeuRequetesData.idJeuRequetes, deleteRequeteFromJeu);
    });

    onUnmounted(() => {
        eventBus.off('addRequeteInJeu' + props.JeuRequetesData.idJeuRequetes);
        eventBus.off('suppRequeteInJeu' + props.JeuRequetesData.idJeuRequetes);
        eventBus.off('insertRequetesFromJeu' + props.JeuRequetesData.idJeuRequetes);
        eventBus.off('deleteRequeteFromJeu' + props.JeuRequetesData.idJeuRequetes);
    });

    return {
        idJeuRequetes,
        requetes,
        requetesNot,
        requetesFrom,
        lRequeteJeuRequetesList,
        showModalModifierJeu,
        showModalRequetesIn,
        showModalRequetesOut,
        loaded,
        handleShowModalRequeteInJeu,
        handleShowModalRequeteNotInJeu,
        deleteJeuRequete,
        insertRequetesFromJeu,
        deleteRequeteFromJeu,
        showNotification,
        notificationMessage,
        notificationType,
        handleNotification
    };
};